import { GridColumnVisibilityModel } from "@mui/x-data-grid-pro";
import { IDashboardSettings } from "components/preferences";
import { SetPreferenceSignature } from "hooks/preferences";
import useDensityHandler from "./useDensityHandler";
import usePersistedPageSize from "./usePersistedPageSize";
import useGridSorting from "./useGridSorting";
import useGridFilters from "./useGridFilters";
import { Sort } from "models/grids";
import { ColumnVisibilityOrOrderChangeHandler } from "./useGridColumns";


type UseGridControllerProps = {
    defaultSort: Sort[];
    visibilityModel?: GridColumnVisibilityModel;
    onColumnChange?: ColumnVisibilityOrOrderChangeHandler;
    settings?: IDashboardSettings | null;
    setSettings?: SetPreferenceSignature;
};

const EmptySetSettings = (params: IDashboardSettings) => {};

const useGridController = (props: UseGridControllerProps) => {
    const {
        defaultSort,
        visibilityModel,
        onColumnChange
    } = props;

    const settings = props.settings ?? null;
    const setSettings = props.setSettings ?? EmptySetSettings;
    
    const [ filter, onFilterChange, filterModel ] = useGridFilters({
        settings,
        setSettings
    });

    const [ sort, onSortChange, sortModel ] = useGridSorting({
        defaultSort: defaultSort,
        settings,
        setSettings
    });
    
    const [ pagination, onPaginationChange ] = usePersistedPageSize({
        settings,
        setSettings: setSettings,
    });
    
    const [ density, onDensityChange ] = useDensityHandler({
        settings,
        setSettings: setSettings,
    });
    
    // const controller = useMemo<IGridController>(() => ({
    //     sort,
    //     sortModel: sortModel,
    //     onSortChange,
    //     filter,
    //     filterModel: filterModel,
    //     onFilterChange,
    //     pagination: pagination,
    //     onPaginationChange,
    //     density: density ?? undefined,
    //     onDensityChange,
    //     visibility: visibilityModel,
    //     onColumnChange,
    //     isFilterApplied: () => (filter.filters?.length ?? 0) > 0
    // }), [
    //     sortModel
    // ]);

    return {
        sort,
        sortModel: sortModel,
        onSortChange,
        filter,
        filterModel: filterModel,
        onFilterChange,
        pagination: pagination,
        onPaginationChange,
        density: density ?? undefined,
        onDensityChange,
        visibility: visibilityModel,
        onColumnChange,
        isFilterApplied: () => (filter.filters?.length ?? 0) > 0
    };

    //return controller;
};

export default useGridController;